import {HeaderInterface} from "./Header.interface";

export const HeaderSchema: HeaderInterface = {
    isMenu: false,
    isModalOpen: false,
    releasePeriod: null,
    recaptchaKey: null,
}
